import { Link } from "react-router-dom";

const COLORS = {
  bg: "#0F172A",
  ink: "#F8FAFC",
  body: "#CBD5E1",
  sub: "#94A3B8",
  line: "rgba(255, 255, 255, 0.08)",
  green: "#34D399",
};

const brandMeta = [
  { label: "대표", value: "최현" },
  { label: "주소", value: "대전광역시 유성구 테크노1로 75, 311호" },
  { label: "사업자등록번호", value: "393-81-02118" },
  { label: "통신판매업신고", value: "제 2025-대전유성-0325 호" },
];

function Footer() {
  return (
    <footer
      style={{
        background: COLORS.bg,
        color: COLORS.body,
        marginTop: 60,
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "64px 32px 28px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1.3fr 1fr 1fr",
            gap: 48,
          }}
        >
          {/* 브랜드 */}
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div
              style={{
                fontSize: 24,
                fontWeight: 800,
                color: COLORS.ink,
                letterSpacing: "-0.02em",
              }}
            >
              뚝딱이
            </div>
            <p
              style={{
                margin: 0,
                fontSize: 14,
                lineHeight: 1.7,
                color: COLORS.body,
                maxWidth: 380,
              }}
            >
              농기계 고장 시, 가까운 수리기사와 가장 빠르게 연결되는
              <br />
              실시간 매칭 플랫폼입니다.
            </p>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 10,
                marginTop: 8,
              }}
            >
              <a
                href="mailto:misolution_design@naver.com"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  padding: "8px 14px",
                  borderRadius: 9999,
                  background: "rgba(255, 255, 255, 0.06)",
                  color: COLORS.ink,
                  fontSize: 13,
                  fontWeight: 500,
                  textDecoration: "none",
                  border: `1px solid ${COLORS.line}`,
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                ✉ misolution_design@naver.com
              </a>
              <a
                href="tel:07075752057"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  padding: "8px 14px",
                  borderRadius: 9999,
                  background: "rgba(255, 255, 255, 0.06)",
                  color: COLORS.ink,
                  fontSize: 13,
                  fontWeight: 500,
                  textDecoration: "none",
                  border: `1px solid ${COLORS.line}`,
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                ☎ 070-7575-2057
              </a>
            </div>
          </div>

          {/* 서비스 */}
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: COLORS.ink,
                letterSpacing: "0.02em",
                textTransform: "uppercase",
              }}
            >
              서비스
            </div>
            <FooterLink to="/main">홈</FooterLink>
            <FooterLink to="/matching">요청 목록</FooterLink>
            <FooterLink to="/community">커뮤니티</FooterLink>
            <FooterLink to="/inquiry">문의하기</FooterLink>
          </div>

          {/* 법적 고지 */}
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: COLORS.ink,
                letterSpacing: "0.02em",
                textTransform: "uppercase",
              }}
            >
              정책
            </div>
            <FooterLink to="/terms" external>이용약관</FooterLink>
            <FooterLink to="/policy" external>개인정보처리방침</FooterLink>
          </div>
        </div>

        <hr
          style={{
            margin: "48px 0 24px",
            border: "none",
            borderTop: `1px solid ${COLORS.line}`,
          }}
        />

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 16,
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "6px 16px",
              fontSize: 12,
              color: COLORS.sub,
              lineHeight: 1.6,
            }}
          >
            <span style={{ fontWeight: 600, color: COLORS.body }}>
              (주)엠아이솔루션
            </span>
            {brandMeta.map((m) => (
              <span key={m.label}>
                <span style={{ color: COLORS.sub }}>{m.label}</span>{" "}
                <span style={{ color: COLORS.body }}>{m.value}</span>
              </span>
            ))}
          </div>
          <div style={{ fontSize: 12, color: COLORS.sub }}>
            © {new Date().getFullYear()} 뚝딱이. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ to, children, external }) {
  return (
    <Link
      to={to}
      target={external ? "_blank" : undefined}
      style={{
        fontSize: 14,
        color: COLORS.body,
        textDecoration: "none",
        transition: "color 0.15s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.color = COLORS.ink)}
      onMouseLeave={(e) => (e.currentTarget.style.color = COLORS.body)}
    >
      {children}
    </Link>
  );
}

export default Footer;
